import type { FC } from "react";
import type { CampaignLifecycleStatus } from "@/layouts/AppLayout/campaignLifecycle";
import { TEXT } from "@/constants/text";
import styles from "@/layouts/AppLayout/CampaignDropdownItem.module.css";

export interface CampaignOption {
  label: string;
  value: number;
  dateRangeLabel: string;
  lifecycleStatus: CampaignLifecycleStatus;
}

const BADGE_LABEL: Record<CampaignLifecycleStatus, string> = {
  active: TEXT.hierarchyBreadcrumb.badgeActive,
  ended: TEXT.hierarchyBreadcrumb.badgeEnded,
  upcoming: TEXT.hierarchyBreadcrumb.badgeUpcoming,
};

const BADGE_CLASS: Record<CampaignLifecycleStatus, string> = {
  active: styles.badgeActive,
  ended: styles.badgeEnded,
  upcoming: styles.badgeUpcoming,
};

const CampaignDropdownItem: FC<{ option: CampaignOption }> = ({ option }) => (
  <div className={styles.row}>
    <div className={styles.text}>
      <span className={styles.name}>{option.label}</span>
      <span className={styles.dateRange}>{option.dateRangeLabel}</span>
    </div>
    <span className={`${styles.badge} ${BADGE_CLASS[option.lifecycleStatus]}`}>
      {BADGE_LABEL[option.lifecycleStatus]}
    </span>
  </div>
);

export default CampaignDropdownItem;
